import { render, staticRenderFns } from "./pwa_article_info.vue?vue&type=template&id=33e1840c&scoped=true&"
import script from "./pwa_article_info.vue?vue&type=script&lang=js&"
export * from "./pwa_article_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1840c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e1840c')) {
      api.createRecord('33e1840c', component.options)
    } else {
      api.reload('33e1840c', component.options)
    }
    module.hot.accept("./pwa_article_info.vue?vue&type=template&id=33e1840c&scoped=true&", function () {
      api.rerender('33e1840c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/item/tabs/pwa_article_info.vue"
export default component.exports